import { useEffect, useRef, useState } from "react";
import { Eye, Smartphone, Monitor } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

const PHASES = [["idle", "Attesa"], ["playing", "Gioco"], ["win", "Vincita"], ["lose", "Non vincita"]];

export default function LivePreview({ contestId, game }) {
  const ref = useRef(null);
  const [ready, setReady] = useState(false);
  const [portrait, setPortrait] = useState(true);
  const [phase, setPhase] = useState("idle");
  const src = `${window.location.origin}/embed/${contestId}?preview=1&format=${portrait ? "portrait" : "landscape"}`;

  useEffect(() => {
    const on = (e) => e.data?.type === "viviwin-preview-ready" && setReady(true);
    window.addEventListener("message", on);
    return () => window.removeEventListener("message", on);
  }, []);

  useEffect(() => {
    if (!ready) return;
    const t = setTimeout(() => ref.current?.contentWindow?.postMessage({ type: "viviwin-preview", game }, "*"), 250);
    return () => clearTimeout(t);
  }, [game, ready]);

  const send = (p) => {
    setPhase(p);
    ref.current?.contentWindow?.postMessage({ type: "viviwin-preview", game, phase: p }, "*");
  };

  return (
    <Card className="p-4 bg-card border-border space-y-3" data-testid="live-preview">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h3 className="font-display font-bold text-base flex items-center gap-2"><Eye className="h-4 w-4" /> Anteprima live</h3>
        <div className="flex gap-1">
          <Button size="sm" variant={portrait ? "default" : "secondary"} onClick={() => { setPortrait(true); setReady(false); }} data-testid="preview-portrait"><Smartphone className="h-3.5 w-3.5" /></Button>
          <Button size="sm" variant={!portrait ? "default" : "secondary"} onClick={() => { setPortrait(false); setReady(false); }} data-testid="preview-landscape"><Monitor className="h-3.5 w-3.5" /></Button>
        </div>
      </div>
      <div className="flex flex-wrap gap-1">
        {PHASES.map(([k, l]) => (
          <button key={k} data-testid={`preview-phase-${k}`} onClick={() => send(k)} className={`text-xs rounded-full px-3 py-1 border ${phase === k ? "border-primary text-primary" : "border-border text-muted-foreground"}`}>{l}</button>
        ))}
      </div>
      <div className={`mx-auto rounded-2xl overflow-hidden border-4 border-slate-800 bg-black shadow-xl ${portrait ? "w-[280px] h-[560px]" : "w-full aspect-video"}`}>
        <iframe key={src} ref={ref} src={src} title="preview" className="w-full h-full" style={{ transformOrigin: "0 0" }} />
      </div>
      <p className="text-[11px] text-muted-foreground">Le modifiche a colori, testi, gioco e videate si riflettono subito qui (senza salvare).</p>
    </Card>
  );
}
